// API endpoints configuration
export const ENDPOINTS = {
    // User & Auth
    profile: () => 'rest/Profile',
    authenticate: () => 'rest/Authenticate',

    // Settings
    settings: () => 'rest/Settings',

    // App Cards
    appCards: () => 'rest/AppCards',

    // Admin
    admin: () => 'rest/Admin',
    adminApp: (id: string) => `rest/Admin/${id}`,
    adminReorder: (id: string, newPosition: number) => `rest/Admin/${id}/reorder/${newPosition}`,

    // Upload
    upload: () => 'rest/Upload',
    deleteUpload: (filename: string) => `rest/Upload/${filename}`,
} as const;

export type ApiEndpoints = typeof ENDPOINTS;
